/**
 * Returns file extension from a valid filename
 * @param {String} filename
 * @return {String} File extension
 * @example
 *   getExtensionFromFilename('sample.file.xlsx') -> xlsx
 */

export default function getExtensionFromFilename(filename = '') {
  if (!filename) return undefined;

  return filename.split('.').pop();
}
